import React from 'react';
import Navbar from './Navbar';
import { HashLink } from 'react-router-hash-link';

const Header = () => {
  return (
    <header className="main_header_area position-absolute w-100 site-header">

      {/* Navigation Bar */}
      <div className="header_menu" id="header_menu">
        <div className="header-content text-white"  style={{backgroundColor:"rgba(255, 255, 255, 0.15)"}}>
          <div className="container">
            <div className="header-content-inner py-2">
              <div className="row align-items-center">
                <div className="col-lg-6">
                </div>

                <div className="col-lg-6">
                  <div className="header-event-info text-end">
                    <ul className="m-0 p-0">
                      <li className="px-2 border-end border-lightgrey border-opacity-50 d-inline">
                        <i className="fa fa-phone pe-1"></i>
                        <small>+48 516 156 423</small>
                      </li>
                      <li className="px-2 border-lightgrey border-opacity-50 d-inline">
                        <i className="fa fa-envelope-o pe-1"></i>
                        <small>biuro&#64;mtcevents.pl</small>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>
        <div className="container">
          <nav className="navbar navbar-expand-lg navbar-light py-2 w-100">
            <div className="row w-100 align-items-center">
              <div className="col-lg-2 col-md-6">
                <div className="navbar-brand m-0">
                  <img src="assets/images/logo/1.png" alt="Logo" className="w-100" />
                </div>
              </div>

              <div className="col-lg-8 col-md-6">
                <Navbar/>
              </div>  

              <div className="col-lg-2">
                <div className="menu-search text-end">
                  <HashLink smooth to="#contact" scroll={el => {
    const yOffset = -60; // adjust based on your fixed navbar height
    const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }} className="btn btn3 fw-bold" style={{ width:"160px", height:"40px", lineHeight:"40px", padding:"0"}}>
                   Kontakt
                  </HashLink>
                </div>
              </div>
            </div>
          </nav>
          <div id="slicknav-mobile"></div>
        </div>
      </div>
    </header>
  );
};

export default Header;
